import { SxProps } from '@mui/material';
import HomeLeftBar from '../../../shared-components/leftbar/HomeLeftBar';
import ProfileCard from './ProfileCard';
import { IUser } from '../../../../../interfaces/user.interface';

interface ProfileLeftBarProps {
  styles?: SxProps;
  navigatePhotos: () => void;
  navigateVideos: () => void;
  hasAccess?: boolean;
  isBlocked?: boolean;
  hasMutualFriends?: boolean;
  user?: IUser;
}
const ProfileLeftBar = ({
  styles,
  navigatePhotos,
  navigateVideos,
  hasAccess,
  isBlocked,
  hasMutualFriends,
  user,
}: ProfileLeftBarProps) => {
  return (
    <HomeLeftBar
      styles={styles}
      cardData={
        <ProfileCard
          hasAccess={hasAccess}
          isBlocked={isBlocked}
          hasMutualFriends={hasMutualFriends}
          user={user}
        />
      }
      navigatePhotos={navigatePhotos}
      navigateVideos={navigateVideos}
    />
  );
};

export default ProfileLeftBar;
